export const LEVELS = {
  1: {
    dimensions: { width: 4, height: 4 },
    objective: {
      itemId: 'NICKEL',
      count: 2,
      description: 'Create 2 Nickels by merging Pennies'
    },
    board: {
      generators: []
    },
    items: [
      { itemId: 'PENNY', position: { row: 1, col: 1 }, frozen: false },
      { itemId: 'PENNY', position: { row: 1, col: 2 }, frozen: false },
      { itemId: 'PENNY', position: { row: 2, col: 1 }, frozen: false },
      { itemId: 'PENNY', position: { row: 2, col: 2 }, frozen: false }
    ],
    rewards: {
      stars: 1,
      gold: 100
    }
  },
  2: {
    dimensions: { width: 4, height: 4 },
    objective: {
      itemId: 'DIME',
      count: 1,
      description: 'Create a Dime by merging Nickels'
    },
    board: {
      generators: [
        { generatorId: 'BASIC_BANKER', position: { row: 3, col: 0 } }
      ]
    },
    items: [
      { itemId: 'NICKEL', position: { row: 1, col: 1 }, frozen: false }
    ],
    rewards: {
      stars: 1,
      gold: 100
    }
  },
  3: {
    dimensions: { width: 5, height: 4 },
    objective: {
      itemId: 'QUARTER',
      count: 1,
      description: 'Create a Quarter by merging Dimes'
    },
    board: {
      generators: [
        { generatorId: 'BASIC_BANKER', position: { row: 3, col: 0 } },
        { generatorId: 'FINANCE_ADVISOR', position: { row: 3, col: 4 } }
      ]
    },
    items: [
      { itemId: 'DIME', position: { row: 1, col: 2 }, frozen: true },
      { itemId: 'PENNY', position: { row: 2, col: 1 }, frozen: true },
      { itemId: 'PENNY', position: { row: 2, col: 3 }, frozen: true }
    ],
    rewards: {
      stars: 1,
      gold: 150
    }
  },
  4: {
    dimensions: { width: 5, height: 5 },
    objective: {
      itemId: 'DOLLAR',
      count: 1,
      description: 'Create a Dollar'
    },
    board: {
      generators: [
        { generatorId: 'BASIC_BANKER', position: { row: 4, col: 0 } },
        { generatorId: 'FINANCE_ADVISOR', position: { row: 4, col: 4 } }
      ]
    },
    items: [
      { itemId: 'QUARTER', position: { row: 1, col: 2 }, frozen: false },
      { itemId: 'NICKEL', position: { row: 2, col: 1 }, frozen: true },
      { itemId: 'NICKEL', position: { row: 2, col: 3 }, frozen: true }
    ],
    rewards: {
      stars: 2,
      gold: 200
    }
  },
  5: {
    dimensions: { width: 6, height: 5 },
    objective: {
      itemId: 'WALLET',
      count: 1,
      description: 'Create a Wallet'
    },
    board: {
      generators: [
        { generatorId: 'BASIC_BANKER', position: { row: 4, col: 0 } },
        { generatorId: 'FINANCE_ADVISOR', position: { row: 4, col: 2 } },
        { generatorId: 'INVESTMENT_BROKER', position: { row: 4, col: 5 } }
      ]
    },
    items: [
      { itemId: 'DOLLAR', position: { row: 1, col: 2 }, frozen: false },
      { itemId: 'QUARTER', position: { row: 2, col: 1 }, frozen: true },
      { itemId: 'QUARTER', position: { row: 2, col: 3 }, frozen: true }
    ],
    rewards: {
      stars: 2,
      gold: 250
    }
  },
  6: {
    dimensions: { width: 6, height: 6 },
    objective: {
      itemId: 'SAFE',
      count: 1,
      description: 'Create a Safe'
    },
    board: {
      generators: [
        { generatorId: 'BASIC_BANKER', position: { row: 5, col: 0 } },
        { generatorId: 'FINANCE_ADVISOR', position: { row: 5, col: 3 } },
        { generatorId: 'INVESTMENT_BROKER', position: { row: 5, col: 5 } }
      ]
    },
    items: [
      { itemId: 'WALLET', position: { row: 2, col: 2 }, frozen: false },
      { itemId: 'DOLLAR', position: { row: 3, col: 3 }, frozen: true }
    ],
    rewards: {
      stars: 3,
      gold: 500
    }
  },
  7: {
    dimensions: { width: 6, height: 6 },
    objective: {
      itemId: 'SAFE',
      count: 2,
      description: 'Create 2 Safes'
    },
    board: {
      generators: [
        { generatorId: 'BASIC_BANKER', position: { row: 5, col: 0 } },
        { generatorId: 'FINANCE_ADVISOR', position: { row: 5, col: 2 } },
        { generatorId: 'INVESTMENT_BROKER', position: { row: 5, col: 4 } }
      ]
    },
    items: [
      { itemId: 'WALLET', position: { row: 1, col: 1 }, frozen: false },
      { itemId: 'WALLET', position: { row: 1, col: 4 }, frozen: false },
      { itemId: 'QUARTER', position: { row: 3, col: 2 }, frozen: true },
      { itemId: 'QUARTER', position: { row: 3, col: 3 }, frozen: true }
    ],
    rewards: {
      stars: 3,
      gold: 750
    }
  }
};

export function createLevel(levelNumber) {
  return LEVELS[levelNumber];
}

export function getTotalLevels() {
  return Object.keys(LEVELS).length;
}
